module.exports = __webpack_public_path__ + "img/camera.098bb41a.png";